import { EntityLayerId, type HasLayerId } from "./EntityLayerId.enum"

type LayerTerrain1 = { layer_id: EntityLayerId.TerrainL1 }

export default function isEntityLayerIdTerrain1<T extends HasLayerId>(obj: T): obj is T & LayerTerrain1 {
  return obj.layer_id === EntityLayerId.TerrainL1
}

